"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.ragStatus.pending': 'Oczekujący',
    'knowledge.ragStatus.processing': 'Przetwarzanie',
    'knowledge.ragStatus.completed': 'Zakończono',
    'knowledge.ragStatus.failed': 'Nieudane',
    'knowledge.ragStatus.not_indexed': 'Nie dotyczy',
};
